// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2_IF0","tabsBox":"styles_tabsBox__1s1aY","createButton":"styles_createButton__3rDXO"};